import * as React from 'react';

import {AiHomepageHeader} from 'shells/ai-homepage/text/ai-homepage-header';
import {KeyTriggeredAnimateIn} from 'shells/animation/key-triggered-animate-in';
import {ScrollTriggeredAnimateIn} from 'shells/animation/scroll-triggered-animate-in';
import {ViewBoardIcon} from 'shells/icon/svg/view-board-icon';
import {Stack} from 'shells/layout/stack/stack';

import type {AiFeaturePeriod} from 'nutshell-graphql-types';

import {AiTabs} from '../shared/components/ai-tabs';

import {FeatureSubsection} from './feature-subsection';
import {
    getAiFeaturesGrouped,
    getAiFeatureGroupingIcon,
    getFeatureGroupingTabLabel,
} from './helpers';
import type {AiFeatureGrouping, TabOption} from './types';

import styles from './features.module.css';

const ALL_TAB_OPTION: TabOption = 'all';

type Props = {
    selectedUsageTab: AiFeaturePeriod;
};

export function FeaturesSection(props: Props) {
    const [selectedTab, setSelectedTab] = React.useState<TabOption>(ALL_TAB_OPTION);

    const featuresGrouped = getAiFeaturesGrouped();
    // @ts-expect-error
    const groupings: Array<AiFeatureGrouping> = Object.keys(featuresGrouped);

    const tabOptions = React.useMemo(
        () => [
            {id: ALL_TAB_OPTION, label: 'All', icon: ViewBoardIcon},
            ...groupings.map((grouping) => ({
                id: grouping,
                label: getFeatureGroupingTabLabel(grouping),
                icon: getAiFeatureGroupingIcon(grouping),
            })),
        ],
        [groupings]
    );

    const filteredGroupings = groupings.filter(
        (grouping) => grouping === selectedTab || selectedTab === ALL_TAB_OPTION
    );

    return (
        // @ts-expect-error
        <KeyTriggeredAnimateIn triggerKey={selectedTab}>
            <div className={styles['features-container']}>
                <Stack justifyContent='space-between' isFullWidth={true} spacing={16}>
                    <AiHomepageHeader text='AI features' />
                    <AiTabs
                        tabs={{
                            options: tabOptions,
                            selectedTab: selectedTab,
                            // @ts-expect-error
                            onChangeTab: (newTab: TabOption) => setSelectedTab(newTab),
                        }}
                    />
                </Stack>
                <Stack spacing={24}>
                    {filteredGroupings.map((grouping) => {
                        const features = featuresGrouped[grouping];

                        return (
                            // @ts-expect-error
                            <ScrollTriggeredAnimateIn key={grouping}>
                                <FeatureSubsection
                                    grouping={grouping}
                                    // @ts-expect-error
                                    features={features}
                                    selectedUsageTab={props.selectedUsageTab}
                                />
                            </ScrollTriggeredAnimateIn>
                        );
                    })}
                </Stack>
            </div>
        </KeyTriggeredAnimateIn>
    );
}
